// Stable fingerprint of a map's data, so a client built against one map can't join a server running
// another. Canonical JSON (object keys sorted, arrays in order) makes key order irrelevant; FNV-1a 64 is
// plenty for telling maps apart and runs synchronously the same in the browser and on the server.
import type { MapData } from './schema.js';

function canonical(v: unknown): string {
  if (Array.isArray(v)) return `[${v.map(canonical).join(',')}]`;
  if (typeof v === 'object' && v !== null) {
    const o = v as Record<string, unknown>;
    return `{${Object.keys(o).sort().map(k => `${JSON.stringify(k)}:${canonical(o[k])}`).join(',')}}`;
  }
  return JSON.stringify(v);
}

const FNV_OFFSET = 0xcbf29ce484222325n, FNV_PRIME = 0x100000001b3n, MASK = (1n << 64n) - 1n;

export function hashMap(map: MapData): string {
  let h = FNV_OFFSET;
  for (const byte of new TextEncoder().encode(canonical(map))) h = ((h ^ BigInt(byte)) * FNV_PRIME) & MASK;
  return h.toString(16).padStart(16, '0');
}
